import {
  IxFetch,
  IxPost,
  IxApi,
  testTokenScope,
  tokenInspected
} from "vue-src/IxPlugin/api"
import {cleanObj, debugLog} from "vue-src/utils"
import Vue from 'vue'

function updateProductCountTab(count) {
  const elt = document.querySelector("#product-tab-count")
  if (elt) {
    elt.textContent = `(${count.toString()})`
  }
}

export default function (overrides = {}) {
  const namespaced = true

  const default_state = {
      filterset_id: undefined,
      filterset_name: undefined,
      _type: undefined,
      filterset: {},
      facets: {},
      filters: {},
      results: [],
      results_total: 0,
      init: undefined,

    }
  const default_getters = {
    getType(state) {
      return state._type
    },
    getInit(state) {
      return state.init
    },
    getFilterDetails(state) {
      let results = {}
      if (state.filterset.filters) {
        state.filterset.filters.forEach(e => {
          results[e.attribute] = {
            name: e.name,
            value_prefix: e.value_prefix,
            value_suffix: e.value_suffix,
            visible: e.visible,
            widget_type: e.widget_type,
          }
        })
      }
      return results
    },
    getSortFields(state){
      return state.filterset.sort_fields?state.filterset.sort_fields:[]
    },
    // getCurrentSort is in the persistent module
  }
  const default_mutations = {

    setInit(state, payload) {
      state.init = payload
    },
    setFilterSetId(state, payload) {
      state.filterset_id = payload
    },
    setFacets(state, payload) {
      state.facets = payload
    },
    setFilters(state, payload) {
      state.filters = payload
    },
    setResults(state, payload) {
      state.results = payload
    },
    setResultsTotal(state, payload) {
      state.results_total = payload
    },
    appendResults(state, payload) {
      state.results = [...state.results, ...payload]
    },
    setFilterSet(state, payload) {
      state.filterset = payload
    },
    resetResults(state){
      state.results= []
      state.results_total=0
    },
    // setCurrentSort is in the persistent module
    updateResult(state, {index, data}) {
      Vue.set(state.results, index, data)
    },
  }


  const default_actions = {
    init({dispatch, state, commit, getters}) {
      let init = dispatch('fetchFilterSet').then(r => dispatch('fetchSearch'))
      commit('setInit', init)
      return init
    },
    fetchSearch({dispatch, state, getters, commit}) {
      let sort = `${getters['getCurrentSort']}`
      /** @type {string[]} */
      const sortFields = getters['getSortFields'].map(e => e.value);
      if (sortFields.indexOf(sort) === -1 && !(state._type === 'mxcategory' && ['name', '-name'].includes(sort))) {
        sort = '_score'
        commit('setCurrentSort', sort)
      }
      commit('resetResults')
      if (!!window.search_results && !!window.search_results.results) {
        const result = dispatch('handleSearchResult', {
          status: 200,
          data: cleanObj(window.search_results)
        })
        window.search_results = undefined
        return result
      }
      let query = {
        rc: 30,
        fs: state.filterset_id,
        o: sort
      }
      if (state._type) {
        query.rt = state._type
      }

      const mxcategory_data = window.mxcategory_data;
      if (state.mxfilter) {
        query.mxcategory = state.mxfilter
      } else if (mxcategory_data) {
        const cat_id = mxcategory_data['id'];
        if (cat_id) {
          query.mxcategory = cat_id;
        }
      }

      return IxFetch(IxApi.search + document.location.search, query)
          .then(r => dispatch('handleSearchResult', r))
    },
    fetchSearchPage({dispatch, state, getters}, page) {
      const query = {
        rc: 30,
        fs: state.filterset_id,
        p: page,
        o: getters['getCurrentSort'],
      }
      if (state._type) {
        query.rt = state._type
      }
      if (state.mxfilter) {
        query.mxcategory = state.mxfilter
      }

      return IxFetch(IxApi.search + document.location.search, query)
          .then(r => dispatch('handleSearchPageResult', r))
    },
    handleSearchResult({dispatch, commit, state}, response) {
      if (response.status === 200) {
        commit('setFacets', response.data.facets)
        commit('setFilters', response.data.filters)
        commit('setResults', response.data.results)
        commit('setResultsTotal', response.data.results_total)
        if (state._type === 'stock_item') {
          updateProductCountTab(response.data.results_total)
        }
        return dispatch('priceResults')
      }
      if (state._type === 'stock_item') {
        updateProductCountTab(0)
      }
      return Promise.reject(response)
    },
    async handleSearchPageResult({dispatch, commit}, response) {
      if (response.status === 200) {
        commit('appendResults', response.data.results)
        return dispatch('priceResults')
      }
      return Promise.reject(response)
    },
    fetchFilterSet({dispatch}) {
      if (!!window.search_filters && window.search_filters.length > 0) {
        return dispatch('handleFilterSets', {
          status: 200,
          data: window.search_filters
        })
      } else {
        return IxFetch(IxApi.search_filtersets)
            .then(r => dispatch('handleFilterSets', r))
      }

    },
    handleFilterSets({commit, state}, response) {
      if (response.status === 200) {
        let fset = response.data.filter(e => e.name === state.filterset_name)[0]
        commit('setFilterSet', fset)
        commit('setFilterSetId', fset.id)
        return Promise.resolve(response)
      }
      return Promise.reject(response)
    },
    async priceResults({commit, state}) {
      await tokenInspected()
      if (testTokenScope('price.read')) {
        let items = state.results.filter(e => e._source.type === 'stock_item' && !e._source.pricing)
            .map(e => e._source.id)
        if (items.length > 0) {
          let response = await IxPost(IxApi.prices, {items: items}),
              cleanResults = cleanObj(state.results)
          debugLog(items, response, cleanResults)
          cleanResults.forEach(function (el, index, arr) {
            if (response.data[el._source.id]) {
              el._source['pricing'] = response.data[el._source.id]
              commit('updateResult', {index: index, data: el})
            }
          })
        }
      }
      return Promise.resolve()
    }
  }

  const default_modules = {}

  const state = {
    ...default_state,
    ...(overrides.state?overrides.state:{}),
  }
  const getters = {
    ...default_getters,
    ...(overrides.getters?overrides.getters:{})
  }
  const mutations = {
    ...default_mutations,
    ...(overrides.mutations?overrides.mutations:{}),
  }

  const actions = {
    ...default_actions,
    ...(overrides.actions?overrides.actions:{}),
  }


  const modules = {
    ...default_modules,
    ...(overrides.modules?overrides.modules:{}),
  }


  return {
    namespaced,
    state,
    getters,
    mutations,
    actions,
    modules,
  }
}






// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/search/_base.js